import React from 'react';
import { Badge, ListGroupItem } from 'react-bootstrap';

const AsideListItem = ({itemCount, text}) => {
  return (
    <ListGroupItem>
      <div className="d-flex justify-content-between aling-items-center">
        <span>{text}</span>
        <Badge pill variant="danger">{itemCount}</Badge>
      </div>
    </ListGroupItem>
  )
}

export default AsideListItem;